
import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GameResults, GameGradeABCEnum, LegacyGame as BaseGame } from 'lingo2-models';
import { IconsService } from '../../services/icons.service';
import { GameStore } from 'lingo2-game-lib';
import { CustomLocaleModule } from '@onclass/oc-custom-locale';

@Component({
  selector: 'app-vocabulary-finish',
  standalone: true,
  imports: [CustomLocaleModule],
  templateUrl: './vocabulary-finish.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./vocabulary-finish.component.scss'],
})
export class VocabularyFinishComponent implements OnInit {
  public results: GameResults = new GameResults();
  private _game: BaseGame = new BaseGame();

  @Input() set game(game: BaseGame | any) {
    if (!game) {
      return;
    }
    this._game = game;
    this.results = game.results;
  }
  get game() {
    return this._game;
  }

  @Input() set isShowConfirmation(isfinished: any) {
    this._isShowConfirmation = !isfinished;
  }

  public get isShowConfirmation() {
    return this._isShowConfirmation;
  }

  // tslint:disable-next-line: no-output-native
  @Output() close = new EventEmitter<any>();
  public _isShowConfirmation = true;
  public svgsetIcon = IconsService.svgsetIconUrl;

  constructor(private readonly gameStore: GameStore) {}

  ngOnInit(): void {
    this.isShowConfirmation = !this.game.options.readOnly;
  }

  public get content_id(): string {
    return this.game.content_id;
  }

  public get gradeABC(): string {
    const grade = GameResults.percentToGrageABC(this.results.percent);
    const symbols = {
      [GameGradeABCEnum.markAplus]: 'A+',
      [GameGradeABCEnum.markA]: 'A',
      [GameGradeABCEnum.markAminus]: 'A-',
      [GameGradeABCEnum.markBplus]: 'B+',
      [GameGradeABCEnum.markB]: 'B',
      [GameGradeABCEnum.markBminus]: 'B-',
      [GameGradeABCEnum.markCplus]: 'C+',
      [GameGradeABCEnum.markC]: 'C',
      [GameGradeABCEnum.markCminus]: 'C-',
      [GameGradeABCEnum.markDplus]: 'D+',
      [GameGradeABCEnum.markD]: 'D',
      [GameGradeABCEnum.markDminus]: 'D-',
      [GameGradeABCEnum.markF]: 'F',
    };
    return symbols[grade] || '?';
  }

  public onConfirm() {
    this.gameStore.forceFinishGame(this._game.id);
    this._isShowConfirmation = false;
  }

  public onContinue() {
    this.gameStore.goToFirstUnansweredSlide(this._game.id);
  }

  public onClose() {
    this.close.emit();
  }
}
